
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { format } from "date-fns";

interface PersonalInfoCardProps {
  personalInfo: {
    first_name: string;
    middle_name?: string;
    last_name: string;
    date_of_birth?: string | Date;
    residency_status: string;
  };
}

const PersonalInfoCard = ({ personalInfo }: PersonalInfoCardProps) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Personal Information</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
          <div>
            <dt className="text-sm text-muted-foreground">First Name</dt>
            <dd className="font-medium">{personalInfo.first_name}</dd>
          </div>
          {personalInfo.middle_name && (
            <div>
              <dt className="text-sm text-muted-foreground">Middle Name</dt>
              <dd className="font-medium">{personalInfo.middle_name}</dd>
            </div>
          )}
          <div>
            <dt className="text-sm text-muted-foreground">Last Name</dt>
            <dd className="font-medium">{personalInfo.last_name}</dd>
          </div>
          <div>
            <dt className="text-sm text-muted-foreground">Date of Birth</dt>
            <dd className="font-medium">
              {personalInfo.date_of_birth
                ? format(new Date(personalInfo.date_of_birth), "PPP")
                : "Not provided"}
            </dd>
          </div>
          <div>
            <dt className="text-sm text-muted-foreground">Residency Status</dt>
            <dd className="font-medium capitalize">
              {personalInfo.residency_status}
            </dd>
          </div>
        </dl>
      </CardContent>
    </Card>
  );
};

export default PersonalInfoCard;
